import { render, staticRenderFns } from "./riesgoBiopsicosocialShow.vue?vue&type=template&id=1c5c046d&"
import script from "./riesgoBiopsicosocialShow.vue?vue&type=script&lang=js&"
export * from "./riesgoBiopsicosocialShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports